/* eslint-disable max-len */
import 'jquery';

$(document).ready(() => {
  const iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
  const android = /(android)/i.test(navigator.userAgent);
  const windowsPhone = /Windows Phone/i.test(navigator.userAgent) || /iemobile/i.test(navigator.userAgent);

  if (iOS) {
    $('body').addClass('iOS');
  }

  if (android) {
    $('body').addClass('android');
  }

  if (windowsPhone) {
    $('body').addClass('windows-phone');
  }
});
